module.exports = __webpack_public_path__ + "img/notifications.e0f1e10b.svg";